import { AnulacionBoletaHonorario } from "./AnulacionBoletaHonorario.enum";
import { BoletaHonorariosEmitida } from "./BoletaHonorariosEmitida";

export class BoletaHonorarioRequest {
   BH: BoletaHonorariosEmitida;
   Motivo: AnulacionBoletaHonorario;
}
